import { Link } from 'react-router-dom';
import { ArrowRight, HelpCircle, LayoutDashboard, LogOut, Settings, Zap } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { brand } from '@/lib/theme/tokens';
import { photo, unsplash } from '@/lib/utils/img';

/**
 * Avatar dropdown — kept lean.
 * Deep links live in the dashboard sidebar, so the menu only carries:
 *   • account summary
 *   • Dashboard (primary CTA)
 *   • Settings + Help (quick utility)
 *   • Sign out
 */
export function ProfileMenu() {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="outline"
          size="sm"
          aria-label="Open account menu"
          className="h-9 gap-1.5 rounded-full p-0 pr-3"
        >
          <img
            src={unsplash(photo.guideF2, { w: 80 })}
            alt=""
            aria-hidden
            className="h-7 w-7 rounded-full object-cover"
            style={{ marginLeft: 1 }}
          />
          <span
            className="hidden items-center gap-1 text-[11px] font-bold sm:inline-flex"
            style={{ color: brand.teal }}
          >
            <Zap size={11} fill={brand.teal} />
            1,240
          </span>
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-60">
        {/* Account summary */}
        <div className="flex items-center gap-3 px-2 py-2">
          <img
            src={unsplash(photo.guideF2, { w: 80 })}
            alt=""
            aria-hidden
            className="h-10 w-10 shrink-0 rounded-full object-cover"
            style={{ border: `2px solid ${brand.teal}` }}
          />
          <div className="min-w-0">
            <div className="font-display text-[14px] font-semibold text-ink">Mehreen S.</div>
            <div className="text-[11px]" style={{ color: brand.teal }}>
              Adventurer · 1,240 pts
            </div>
          </div>
        </div>

        <DropdownMenuSeparator />

        <DropdownMenuItem asChild>
          <Link to="/dashboard">
            <LayoutDashboard size={14} style={{ color: brand.teal }} />
            <span className="flex-1 font-semibold">My dashboard</span>
            <ArrowRight size={12} className="text-ink-mute" />
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <Link to="/dashboard/settings">
            <Settings size={14} className="text-ink-dim" />
            <span className="flex-1">Settings</span>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuItem asChild>
          <Link to="/help">
            <HelpCircle size={14} className="text-ink-dim" />
            <span className="flex-1">Help center</span>
          </Link>
        </DropdownMenuItem>

        <DropdownMenuSeparator />

        <DropdownMenuItem
          className="focus:bg-[var(--color-err)]/10"
          style={{ color: 'var(--color-err)' }}
        >
          <LogOut size={14} />
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
